/* assets/armonia-header.js
   Menu mobile (apri/chiudi, focus trap, Esc), contatore preferiti,
   sync contatori carrello, apertura cart drawer (se presente),
   header compatto su desktop quando si scorre (classe .is-compact). */
(function () {
  'use strict';

  var A = (window.Armonia = window.Armonia || {});
  var root = document.documentElement;
  var menu = document.getElementById('armonia-menu');
  var openers = document.querySelectorAll('[data-armonia-menu-open]');
  var lastTrigger = null;

  var FOCUSABLE = 'a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])';

  /* ---------- Menu mobile ---------- */
  function openMenu(trigger) {
    if (!menu) return;
    lastTrigger = trigger || document.activeElement;
    menu.hidden = false;
    root.classList.add('armonia-menu-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var close = menu.querySelector('[data-armonia-menu-close]');
    if (close) close.focus();
    if (A.track) A.track('menu_open', { position: 'mobile' });
  }

  function closeMenu() {
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    root.classList.remove('armonia-menu-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  openers.forEach(function (b) {
    b.addEventListener('click', function () { openMenu(b); });
  });

  if (menu) {
    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-armonia-menu-close]')) closeMenu();
    });

    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMenu();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(menu.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* Se si passa a desktop con il menu aperto, chiudilo */
  if (window.matchMedia) {
    var mq = window.matchMedia('(min-width: 1200px)');
    var onChange = function (e) { if (e.matches) closeMenu(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  /* ---------- Preferiti: contatore (lista in localStorage 'favorites') ---------- */

  /* I preferiti si leggono anche se armonia-global.js non ha ancora girato.
     Nel tema quel file è caricato in fondo al body con defer, quindi gira DOPO gli script
     delle sezioni: chi leggeva Armonia.storage all'avvio trovava sempre una lista vuota.
     Qui si usa Armonia.storage quando c'è, altrimenti si legge la stessa chiave a mano. */
  var FAV_KEY = 'armonia:favorites';
  function favStore() { return (window.Armonia && window.Armonia.storage) || null; }
  function favRead() {
    var s = favStore();
    var l;
    if (s) { l = s.get('favorites', []); }
    else {
      try { var raw = window.localStorage.getItem(FAV_KEY); l = raw === null ? [] : JSON.parse(raw); }
      catch (e) { l = []; }
    }
    return Array.isArray(l) ? l : [];
  }
  function favWrite(list) {
    var s = favStore();
    if (s) return s.set('favorites', list);
    try { window.localStorage.setItem(FAV_KEY, JSON.stringify(list)); return true; } catch (e) { return false; }
  }

  function renderFavCount() {
    var list = favRead();
    var n = list.length;
    document.querySelectorAll('[data-armonia-fav-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  renderFavCount();
  window.addEventListener('storage', renderFavCount);
  document.addEventListener('armonia:favorites-changed', renderFavCount);

  /* ---------- Contatore carrello: Dawn aggiorna #cart-icon-bubble, noi copiamo il valore sugli altri ---------- */
  function syncCart() {
    var src = document.querySelector('#cart-icon-bubble [data-armonia-cart-source]');
    if (!src) return;
    var count = src.getAttribute('data-count') || '0';
    var label = src.getAttribute('data-label') || '';
    document.querySelectorAll('[data-armonia-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
    document.querySelectorAll('.armonia-header__cart-m').forEach(function (el) {
      if (label) el.setAttribute('aria-label', label);
    });
  }
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && 'MutationObserver' in window) {
    new MutationObserver(syncCart).observe(bubble, { childList: true, subtree: true, attributes: true });
  }
  syncCart();

  /* ---------- Cart drawer (se il tema lo ha attivo): i link carrello lo aprono ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-armonia-cart-link]');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    if (link.id === 'cart-icon-bubble') return; /* ci pensa già Dawn */
    e.preventDefault();
    closeMenu();
    drawer.open(link);
  });

  /* ---------- Barra categorie desktop: frecce "altre voci" + categoria corrente in vista ---------- */
  (function () {
    var list = document.querySelector('[data-armonia-bar-list]');
    if (!list) return;
    var prev = document.querySelector('[data-armonia-bar-prev]');
    var next = document.querySelector('[data-armonia-bar-next]');

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      var x = list.scrollLeft;
      if (next) next.hidden = !(max > 2 && x < max - 2);
      if (prev) prev.hidden = !(max > 2 && x > 2);
    }
    function go(dir) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({ left: dir * list.clientWidth * 0.6, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (next) next.addEventListener('click', function () { go(1); });
    if (prev) prev.addEventListener('click', function () { go(-1); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);

    if (list.scrollWidth > list.clientWidth) {
      var cur = list.querySelector('.is-current, [aria-current="page"]');
      if (cur) list.scrollLeft = Math.max(0, cur.offsetLeft - (list.clientWidth - cur.offsetWidth) / 2);
    }
    update();
  })();

  /* ---------- Desktop: header compatto quando si scorre ----------
     Si stringe dopo 80px e torna grande sotto 10px (scarto ampio: niente sfarfallio,
     perché la riga che si accorcia di 24px sposta la pagina). */
  (function () {
    var header = document.querySelector('.armonia-header');
    if (!header) return;
    var desktop = window.matchMedia('(min-width: 1200px)');
    var compact = false;
    var ticking = false;

    function apply() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      var next = desktop.matches && (compact ? y > 10 : y > 80);
      if (next !== compact) {
        compact = next;
        header.classList.toggle('is-compact', compact);
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (desktop.addEventListener) desktop.addEventListener('change', apply);
    apply();
  })();
})();
